import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  Spinner,
  Center,
} from "@chakra-ui/react";

export const ModalBox = ({
  title,
  isOpen,
  onClose,
  children,
  styleProps,
  modalProps,
  size = "lg",
  loading,
}) => {
  return (
    <Modal
      blockScrollOnMount={true}
      isOpen={isOpen}
      size={size}
      onClose={onClose}
      {...modalProps}
    >
      <ModalOverlay />
      <ModalContent {...styleProps}>
        <ModalHeader borderBottom="1px solid #eee">{title}</ModalHeader>
        <ModalCloseButton top="17px" />
        {loading && (
          <Center>
            <Spinner />
          </Center>
        )}
        {children}
      </ModalContent>
    </Modal>
  );
};
